// import React, { useEffect, useRef, useState } from "react";
// import { Space, Table } from "antd";
// import '../../cssfiles/homepage.css';
// import { TextField, InputAdornment, Typography, Checkbox, FormControlLabel, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
// import { useSelector } from 'react-redux';
// import {getdashboardgrouplist, getdashboarlist, createdashboardgroup, createdashboardname, deletedahboard} from '../../Restclient/datacollection';
// import CustomTextField from "../CommonComponents/CustomTextField";

// export default function UserManagement() {
//     return (
//         <div className="compliance-config">
//             <Typography className="config-heading" style={{ fontSize: '36px', fontWeight: 700, color: "var(--HighlightedText_Stroke)" }}>User Management</Typography>
//             {/* <Typography className='config-info' style={{ fontSize: '14px', fontWeight: 400, color: "var(--GreyVariation_4)" }}>Customize settings based on your personal preferences. This is for your user login only and does not affect other users in your organization.</Typography> */}
//             <UserList/>
//         </div>
//     )
// }




// function UserList() {
//     const [searchTerm, setSearchTerm] = useState("");
//     const [userList, setUserList] = useState([
//         { key: 1, username: 'User1', access: 'Admin', lastActive: '2023-10-01', dateAdded: '2023-01-01' },
//         { key: 2, username: 'User2', access: 'Editor', lastActive: '2023-09-15', dateAdded: '2023-02-15' },
//         { key: 3, username: 'User3', access: 'Viewer', lastActive: '2023-08-20', dateAdded: '2023-03-20' },
//         { key: 4, username: 'User4', access: 'Admin', lastActive: '2023-07-10', dateAdded: '2023-04-10' },
//         { key: 5, username: 'User5', access: 'Editor', lastActive: '2023-06-05', dateAdded: '2023-05-05' },
//         { key: 6, username: 'User6', access: 'Viewer', lastActive: '2023-05-25', dateAdded: '2023-06-25' },
//         { key: 7, username: 'User7', access: 'Admin', lastActive: '2023-04-15', dateAdded: '2023-07-15' },
//         { key: 8, username: 'User8', access: 'Editor', lastActive: '2023-03-20', dateAdded: '2023-08-20' },
//         { key: 9, username: 'User9', access: 'Viewer', lastActive: '2023-02-10', dateAdded: '2023-09-10' },
//         { key: 10, username: 'User10', access: 'Admin', lastActive: '2023-01-05', dateAdded: '2023-10-05' },
//         // ...additional static user data...
//     ]);

//     const handleSearch = (e) => {
//         setSearchTerm(e.target.value);
//     };

//     const handleAddUser = () => {
//         // Logic to add a new user
//     };

//     const filteredUsers = userList.filter(user =>
//         user.username.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     const columns = [
//         {
//             title: 'Username',
//             dataIndex: 'username',
//         },
//         {
//             title: 'Access',
//             dataIndex: 'access',
//         },
//         {
//             title: 'Last Active',
//             dataIndex: 'lastActive',
//             sorter: (a, b) => new Date(a.lastActive) - new Date(b.lastActive),
//         },
//         {
//             title: 'Date Added',
//             dataIndex: 'dateAdded',
//         },
//     ];

//     return (
//         <div style={{ marginTop: '20px' }}>
//             <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
//                 <TextField
//                     id="search-users"
//                     variant="standard"
//                     label="Search Users"
//                     value={searchTerm}
//                     onChange={handleSearch}
//                     sx={{
//                         width: '300px',
//                         '& .MuiInputBase-input:focus': {
//                             color: 'var(--HighlightedText_Stroke)',
//                         },
//                         '& .MuiInputBase-root': {
//                             fontFamily: 'Roboto',
//                             fontSize: '18px',
//                             fontWeight: '700',
//                             color: 'var(--PrimaryText)'
//                         },
//                         '& .MuiInput-root .MuiInputBase-input': {
//                             padding: 0,
//                         },
//                         '& .MuiInputBase-root::before': {
//                             borderBottom: '1px solid var(--PrimaryText)',
//                         },
//                         '& .MuiInputBase-root::after': {
//                             borderBottom: '2px solid var(--HighlightedText_Stroke)',
//                         },
//                         "& .MuiInputBase-input.Mui-disabled": {
//                             WebkitTextFillColor: "var(--PrimaryText)",
//                         },
//                     }}
//                     style={{ marginRight: '10px' }}
//                 />
//                 <button
//                     style={{
//                         padding: '8px 20px',
//                         backgroundColor: 'var(--LK_BrandBlue)',
//                         color: 'var(--White)',
//                         border: 'none',
//                         borderRadius: '20px',
//                         fontSize: '16px',
//                         fontWeight: 700,
//                         fontFamily: 'Roboto',
//                         cursor: 'pointer',
//                         marginLeft: '10px'
//                     }}
//                     onClick={handleAddUser}
//                 >
//                     Add User
//                 </button>
//             </div>
//             <Table
//                 columns={columns}
//                 dataSource={filteredUsers}
//                 pagination={false}
//                 // scroll={{ y: 440 }}
//                 className="anttable"
//             />
//         </div>
//     );
// }


import React from 'react';
import { Table, Typography } from 'antd';

const { Title } = Typography;

// const data = [
//   {
//     group: {
//       groupid: '1b1f6fe6-5d9b-43cb-971d-9ebc65781667',
//       groupname: 'Energy Management',
//       label: 'Energy Management',
//       pagename: 'Energy Management',
//     },
//     subgroup: [
//       {
//         Dashboardname: 'Energy Analytics',
//         dashboard_pro: '4e2ea765-f3a6-4581-a48f-a46d973299cf',
//         label: 'Energy Analytics',
//         pagename: 'Energy Analytics',
//       },
//       {
//         Dashboardname: 'Energy Accounting',
//         dashboard_pro: 'f0e07022-213c-45f5-b56f-9d9a2eaf2b99',
//         label: 'Energy Accounting',
//         pagename: 'Energy Accounting',
//       },
//       {
//         Dashboardname: 'Power Quality',
//         dashboard_pro: '183b4142-95c3-4275-82aa-e5de161851f5',
//         label: 'Power Quality',
//         pagename: 'Power Quality',
//       },
//       {
//         Dashboardname: 'Status Table',
//         dashboard_pro: '736bb2ac-baa5-4d2a-ac0f-f8d8a1ddcd79',
//         label: 'Status Table',
//         pagename: 'Status Table',
//       },
//     ],
//   },
//   // Add other groups here...
// ];

const data = [{"group":{"groupid":"1b1f6fe6-5d9b-43cb-971d-9ebc65781667","groupname":"Energy Management","label":"Energy Management","pagename":"Energy Management"},"subgroup":[{"Dashboardname":"Energy Analytics","dashboard_pro":"4e2ea765-f3a6-4581-a48f-a46d973299cf","label":"Energy Analytics","pagename":"Energy Analytics"},{"Dashboardname":"Energy Accounting","dashboard_pro":"f0e07022-213c-45f5-b56f-9d9a2eaf2b99","label":"Energy Accounting","pagename":"Energy Accounting"},{"Dashboardname":"Power Quality","dashboard_pro":"183b4142-95c3-4275-82aa-e5de161851f5","label":"Power Quality","pagename":"Power Quality"},{"Dashboardname":"Status Table","dashboard_pro":"736bb2ac-baa5-4d2a-ac0f-f8d8a1ddcd79","label":"Status Table","pagename":"Status Table"}]},{"group":{"groupid":"e25e33c2-20ca-413f-84b3-fb3e6bdbc126","groupname":"Compliance","label":"Compliance","pagename":"Compliance"},"subgroup":[{"Dashboardname":"Environment","dashboard_pro":"830e7727-5c9a-45ff-bd6f-a5a34f7c6db1","label":"Environment","pagename":"Environment"},{"Dashboardname":"Social","dashboard_pro":"320b2b68-4361-45a1-b685-b7e8b4d24cbd","label":"Social","pagename":"Social"},{"Dashboardname":"Governance","dashboard_pro":"d7a2757a-50d4-45c6-8c57-647251d2ae40","label":"Governance","pagename":"Governance"}]},{"group":{"groupid":"ec46341c-a406-464f-9b4b-02fa2de43e43","groupname":"Asset Management","label":"Asset Management","pagename":"Asset Management"},"subgroup":[{"Dashboardname":"Periodic Maintenance","dashboard_pro":"8b0425d7-8211-4fec-b497-6939a523e61b","label":"Periodic Maintenance","pagename":"Periodic Maintenance"}]},{"group":{"groupid":"38dfff3f-3f7b-4b96-9ae7-5a3ea104189f","groupname":"Diagnostics","label":"Diagnostics","pagename":"Diagnostics"},"subgroup":[{"Dashboardname":"Diagnostics","dashboard_pro":"71b85cf0-f0ae-4cdb-93c2-a6b2a6c468bb","label":"Diagnostics","pagename":"Diagnostics"}]},{"group":{"groupid":"ffe633bb-e9ef-4aa1-a100-1183fe27e532","groupname":"Digital Twin","label":"Digital Twin","pagename":"Digital Twin"},"subgroup":[{"Dashboardname":"Digital Twin","dashboard_pro":"ed1fcb31-14f1-4cd2-a32b-768a9649e8b6","label":"Digital Twin","pagename":"Digital Twin"}]},{"group":{"groupid":"d8c84153-201a-44ef-afb9-97efe55590f3","groupname":"BBT","label":"BBT","pagename":"BBT"},"subgroup":[{"Dashboardname":"BBT","dashboard_pro":"5b7d81cf-9dcf-408b-9917-393d3210f511","label":"BBT","pagename":"BBT"}]},{"group":{"groupid":"afdcb4d9-9e9a-4075-90b5-b480672ede61","groupname":"Billing","label":"Billing","pagename":"Billing"},"subgroup":[{"Dashboardname":"Customer","dashboard_pro":"498c2832-88f0-44e7-91f9-eb7b3817a12c","label":"Customer","pagename":"Customer"},{"Dashboardname":"Meter","dashboard_pro":"2c3795f6-6fbf-4981-bd71-d99a5a52ecf8","label":"Meter","pagename":"Meter"},{"Dashboardname":"Tariff","dashboard_pro":"183fa96d-57f4-4459-871e-39866eb64070","label":"Tariff","pagename":"Tariff"},{"Dashboardname":"Billing","dashboard_pro":"9e0777b4-08a1-4a16-97fd-c42200f8109b","label":"Billing","pagename":"Billing"}]},{"group":{"groupid":"34ef4854-f772-4048-a823-1eee6cc0b8f2","groupname":"SLD","label":"SLD","pagename":"SLD"},"subgroup":[{"Dashboardname":"SLD","dashboard_pro":"c2ff10cc-b14f-457c-8319-6481071a5d9f","label":"SLD","pagename":"SLD"}]},{"group":{"groupid":"41bebea5-99cc-40b6-a76a-de927f8e242d","groupname":"Overview","label":"Overview","pagename":"Overview"},"subgroup":[{"Dashboardname":"Overview","dashboard_pro":"cc1e9de4-596d-4a6a-99b8-71a3a1083d45","label":"Overview","pagename":"Overview"},{"Dashboardname":"TestDashboard","dashboard_pro":"d7150876-1b25-4cc2-8af5-a23128e3ca32","label":"TestDashboard","pagename":"TestDashboard"},{"Dashboardname":"tert14","dashboard_pro":"87d97bcd-fea8-4b7b-95ba-fa1644fc50a8","label":"tert14","pagename":"tert14"}]}]

const columns = [
    {
      title: 'Group Name',
      dataIndex: 'groupname',
      key: 'groupname',
      render: (text) => <Typography.Text>{text}</Typography.Text>,
    },
    {
      title: 'Subgroup',
      dataIndex: 'subgroup',
      key: 'subgroup',
      render: (subgroup) => (
        <div>
          {subgroup.map((item, index) => (
            <Typography.Text key={index} style={{ display: 'block' }}>
              {item.Dashboardname}
            </Typography.Text>
          ))}
        </div>
      ),
    },
  ];
const DashboardTable = () => {
  const tableData = data.map((item) => ({
    key: item.group.groupid,
    groupname: item.group.groupname,
    subgroup: item.subgroup,
  }));

  return (
    <div>
      <Title level={3}>Dashboard Groups</Title>
      <Table columns={columns} dataSource={tableData} pagination={false} />
    </div>
  );
};

export default DashboardTable;